import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button } from 'semantic-ui-react';
import * as yup from 'yup';
import moment from "moment";
import { DateData } from '../../formikInput/date';

import AddTitleBar from '../../titleBar/addTitleBar';
import CityDropdown from '../../dropdowns/cityDropdown';
import LoadingPlaceholder from '../../placeholder/loadingPlaceholder';

//Redux Action
import { updateTarget, getTarget } from '../../../redux/actions/targetMasterActions';

let date = new Date();

const EditTarget = (props) => {
    const [targetData, setTargetData] = useState()
    const [targetId, setTargetId] = useState()
    const { getTarget, updateTarget, targetLoading } = props;

    useEffect(() => {
        const id = props?.location?.state?.id;
        setTargetData(JSON.parse(props?.location?.state?.data))
        setTargetId(id)
        getTarget(id)
    }, [])


    if (targetLoading) {

        return (
            <React.Fragment>
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else {
        //Formik
        const initialValues = {
            target_sales_no: targetId ? targetData.target_sales_no : '',
            target_sales_amt: targetData ? targetData.target_sales_amt : '',
            target_payment_ex: targetData ? targetData.target_payment_ex : '',
            target_receivable_amt: targetData ? targetData.target_receivable_amt : '',
            monthYear: targetData ? date.setFullYear(targetData.year, targetData.month - 1) : '',
        }

        const validateSchema = yup.object().shape({
            target_sales_no: yup.number().integer("Target Sales Number is integer only")
                .required('Target Sales Number is Required')
                .typeError('Target Sales Number must specify a number only'),
            target_sales_amt: yup.number().required('Target Sales Amount is Required').typeError('Target Sales Number must specify a number only'),
            target_payment_ex: yup.number().integer("Target Payment is integer only").required('Target Payment is Required').typeError('Target Sales Number must specify a number only'),
            target_receivable_amt: yup.number().required('Target Receivable Amount is Required').typeError('Target Sales Number must specify a number only'),
            monthYear: yup.mixed().required('Month and Year is Required'),
        })
        const onSubmit = (values, onSubmitProps) => {
            const customerNumber = localStorage.getItem('customerNo');
            const userId = localStorage.getItem('userId');
            const { target_sales_no,
                target_sales_amt,
                target_payment_ex,
                target_receivable_amt, monthYear } = values;
            const updateTargetData = {
                target_sales_no,
                target_sales_amt,
                target_payment_ex,
                target_receivable_amt,
                month: new Date(monthYear).getMonth() + 1,
                year: new Date(monthYear).getFullYear(),
                customer_no: customerNumber,
                user_id: userId
            };
            updateTarget(updateTargetData, targetId).then(() => {
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
            });

        };


        return (
            <React.Fragment>
                <AddTitleBar title="Edit Target" LinkName="/target" />
                <div className="m-2">
                    <Formik
                        enableReinitialize
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}
                    >
                        {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                            <>
                                <Segment>
                                    <div className="ui form tiny">
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Month Year</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="8">
                                                <DateData
                                                    name={`monthYear`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="MMMM yyyy"
                                                    showMonthYearPicker
                                                    placeholderText="Select Month and Year"
                                                    selected={moment(values.monthYear, 'MMMM yyyy')}
                                                    selectsStart
                                                    timeIntervals={5}
                                                    disabled
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                /><br />
                                                {touched.monthYear && errors.monthYear ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.monthYear}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Target Sales No<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="target_sales_no" placeholder="Target Sales No" />
                                                {touched.target_sales_no && errors.target_sales_no ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.target_sales_no}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Target Sales Amount<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="target_sales_amt" placeholder="Type Name" />
                                                {touched.target_sales_amt && errors.target_sales_amt ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.target_sales_amt}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Target Payment Ex<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="target_payment_ex" placeholder="Code" />
                                                {touched.target_payment_ex && errors.target_payment_ex ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.target_payment_ex}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Target Receivable Amount<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="target_receivable_amt" placeholder="Type Name" />
                                                {touched.target_receivable_amt && errors.target_receivable_amt ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.target_receivable_amt}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                    </div>
                                </Segment>
                                <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                            </>
                        )}
                    </Formik>
                </div>
            </React.Fragment>
        )
    }
}

const mapStatetoProps = (state) => ({
    targetData: state.getTargetData.target.data,
    targetLoading: state.getTargetData.isLoading

})


export default connect(mapStatetoProps, { updateTarget, getTarget })(EditTarget)


